// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"07ec68ed","106":"6ea48ee0","478":"67477935","502":"a87bd228","949":"6dfd37a4"}[chunkId] + ".chunk.css";
};